module.exports = __webpack_public_path__ + "img/img_show1.d0872952.jpg";